import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "q-ml-auto text-right" }

import { ref } from "vue";
import { sessionApiStore } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import {
  CardPage,
  PasswordInput,
  Typography,
  EmailInput,
  TextButton,
} from "@/components";


/**
 * Displays the create account page.
 */
const __default__ = {
  name: "CreateAccountView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const email = ref("");
const password = ref("");
// const emailConsent = ref(false);

/**
 * Navigates to the login page.
 */
function handleLogin() {
  navigateTo(Routes.LOGIN_ACCOUNT);
}

/**
 * Attempts to create a new account.
 */
function handleCreateAccount() {
  sessionApiStore.handleCreateAccount({
    email: email.value,
    password: password.value,
  });
  email.value = "";
  password.value = "";
  // emailConsent.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardPage), null, {
    form: _withCtx(() => [
      _createVNode(_unref(Typography), {
        align: "center",
        variant: "title",
        el: "h1",
        value: "Welcome to SAFA!"
      }),
      (!_unref(sessionApiStore).createdAccount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Typography), {
              el: "p",
              value: "There are just a few key pieces of info we need to set up your account."
            }),
            _createVNode(_unref(EmailInput), {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "error-message": _unref(sessionApiStore).createErrorMessage,
              "data-cy": "input-new-email"
            }, null, 8, ["modelValue", "error-message"]),
            _createVNode(_unref(PasswordInput), {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              "data-cy": "input-new-password"
            }, null, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            el: "p",
            value: "Your account has been successfully created. Please check your email to\n        complete the sign up process."
          }))
    ]),
    actions: _withCtx(() => [
      (!_unref(sessionApiStore).createdAccount)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            color: "primary",
            label: "Create",
            disabled: password.value.length === 0,
            "data-cy": "button-create-account",
            onClick: handleCreateAccount
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_unref(Typography), { value: "Already have an account?" }),
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "Login",
          class: "q-px-sm",
          color: "primary",
          "data-cy": "button-create-account-login",
          onClick: handleLogin
        })
      ])
    ]),
    _: 1
  }))
}
}

})